import { forwardRef, useCallback, useEffect } from 'react';
import { useNavigatedToNewWindow } from '@dbh/navigate-to-new-tab-or-window';
import styled from 'styled-components';
import '@dbh/styled-helpers';
import { jsx } from 'react/jsx-runtime';

/*
 *
 * Constants: `@dbh/dangerous-html`.
 *
 */const DANGEROUS_HTML_ELEMENT_CLASSNAME="dbh-dangerous-html-container";

const StyledDangerousHtml=/*#__PURE__*/styled.div.withConfig({componentId:"sc-13bhjc7-0"})(["width:100%;& *{color:#4C4C4C !important;font-size:1.6rem;white-space:inherit !important;line-height:inherit !important;}& a{text-decoration:underline;}& strong,& b{font-weight:500 !important;}& p{margin-bottom:1.6rem;}& p:last-child{margin-bottom:0;}& h3{padding-top:1.6rem;font-size:2.4rem;}& h2{font-size:2rem;font-weight:500;}"]);var StyledDangerousHtml$1 = StyledDangerousHtml;

const DangerousHtml=/*#__PURE__*/forwardRef((a,b)=>{let{html:c,className:d}=a;const e=useNavigatedToNewWindow(),f=useCallback(a=>{a.onclick=()=>{const b=a.href;e(b);};},[e]),g=d||DANGEROUS_HTML_ELEMENT_CLASSNAME;return useEffect(()=>{// We want to intercept clicks on hardcoded `URLs`, in the `HTML` content
// sent in the `/webpages` `API` by the admin. These `URLs` can be to our
// site or to external sites.
// @see {@link https://test.daybreakhotels.com/IT/it-IT/29/day-use-hotel/day-spa/camera-con-spa/cagliari}
// @see {@link https://test.daybreakhotels.com/US/en-US/6/day-use-hotel-room}
const a=document.getElementsByClassName(g);for(const b of a){const a=b.getElementsByTagName("a");for(const b of a)f(b);}},[c,f,g]),/*#__PURE__*/jsx(StyledDangerousHtml$1,{className:g,dangerouslySetInnerHTML:{__html:c},ref:b})});DangerousHtml.displayName="DangerousHtml";

export { DangerousHtml as default };
